  import { mapState } from 'vuex'
  export default {
    computed: {
      ...mapState({
        filter: ({ filtersStore: {filter} }) => filter,
        queries: ({ resourcesStore: {queries} }) => queries
      }),
    },
    methods: {
      activateResourcesFilter: function(type, id, title) {
        let updateQuery = JSON.parse(JSON.stringify(this.queries.videos));
        const currentQueryFilters = updateQuery.filters;

        updateQuery.filters = {
          ...currentQueryFilters,
          resources: Object.fromEntries(
            Object.entries(currentQueryFilters.resources || {})
            .filter(([_, value]) => value !== id)
            .concat(
              Object.values(currentQueryFilters.resources || {}).includes(id)
              ? [] 
              : [[Object.keys(currentQueryFilters.resources || {}).length, id]]
              )
            )
        };
        if (Object.keys(updateQuery.filters.resources).length === 0) {
          delete updateQuery.filters.resources;
        }

        let currentFilters = JSON.parse(JSON.stringify(this.filter[type]));

        let updatedResources = currentFilters[type].includes(id)
        ? currentFilters[type].filter(resourceId => resourceId !== id) 
        : [...currentFilters[type], id]; 

        let updatedTitle = updatedResources.length === 0 
        ? title 
        : 'Actieve ' + title.charAt(0).toLowerCase() + title.slice(1) + ': ' + updatedResources.length;

        currentFilters = {
          title: updatedTitle,
          [type]: updatedResources,
          type: [type]
        };
        updateQuery.pagination.page = 1;

        this.$store.commit('filtersStore/setFilterNew', currentFilters);
        this.$store.commit('resourcesStore/updateQuery', updateQuery);
        this.$store.dispatch('resourcesStore/getResources', updateQuery);
      },

    }
  }